import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatUSD(value) {
  const n = Number(value || 0);
  return n.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function cleanOperatorName(name = "") {
  return name.replace(/\s*\(CLP\)\s*/i, "").trim();
}

const ZERO_DECIMAL_CCY = new Set(["CLP", "MXN"]);

export function formatLocal(amount, currency) {
  const code = (currency || "USD").toUpperCase();
  const n = Number(amount || 0);
  if (ZERO_DECIMAL_CCY.has(code)) {
    return `${Math.round(n).toLocaleString("en-US")} ${code}`;
  }
  return `${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${code}`;
}
